module.exports = __webpack_public_path__ + "f5d033c6a1940235f0432699c9bdb30c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/popcorn.png
// module id = 2095
// module chunks = 0